import React from 'react'
import PropTypes from 'prop-types';

export const AskAnExpertThankYou = (props) => {

    const {
        onNewMessage
    } = props;

    return (
        <section className="container">
            <div className="row text-center">
                <hr/>
                <h2 classname="h2">Thank you for message!</h2>
                <p className="p-tag">Your message was sent successfully. We will be in touch shortly.</p>

                <button type="button" className="btn btn-primary--ghost back" onClick={onNewMessage}>
                    <span className="label">Send new message</span>
                </button>

            </div>
        </section>
    )

}

AskAnExpertThankYou.propTypes = {
    onNewMessage: PropTypes.func
}



// WEBPACK FOOTER //
// src/client/components/site/features/askanexpert/form/AskAnExpertThankYou.js